export const dateFormats = {
	prettyShort: 'd MMM yyyy',
	dbDate: 'yyyy-MM-dd',
};
